import React from "react";
import { useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';

const CustomFalseCeilingSection = (props: any) => {
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);

  const showAxisView = (view) => {
    const viewPoint = pageDetails?.images?.filter((e) => e.name === view);
    return (
      viewPoint?.[0]?.imageUrl ?
        <img crossOrigin="anonymous" alt={view} src={viewPoint?.[0]?.imageUrl} className="image-view" /> : <>
          <h4>A view of </h4>
          <p>Section of False Ceiling across X-Axis showing levels</p>
        </>
    )
  }

  return (
    <section className={style.ceiling_plan_section}>
      <h4 className="section_heading">3. False Ceiling Section</h4>
      <div className={style.ceiling_section_container}>
        <div>
          <h4 className="sub_tab_heading">Section along X-Axis</h4>
          <div className={style.canvas_view_description_section}>
            {showAxisView(`AA'`)}
          </div>
        </div>
        <div className={style.reflected_plan}>
          <h4 className="sub_tab_heading">Legend (Electrical)</h4>
          <div className={style.canvas_view_description_section}>
            {showAxisView(`BB'`)}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CustomFalseCeilingSection;